import { CheckCircle2, XCircle } from "lucide-react";
import { Card, formatDate, formatDateTime } from "../../ui";

const ApprovalEntry = ({ a }) => (
  <li className="flex items-start gap-3 text-sm">
    {a.action === "approve" ? (
      <CheckCircle2 size={16} className="text-emerald-600 mt-0.5" />
    ) : (
      <XCircle size={16} className="text-rose-600 mt-0.5" />
    )}
    <div>
      <div>
        <strong>{a.director_name}</strong> {a.action === "approve" ? "aprovou" : "rejeitou"}
        <span className="text-xs text-slate-500 ml-2">{formatDateTime(a.decided_at)}</span>
      </div>
      {a.reason && <div className="text-xs text-slate-600">Motivo: {a.reason}</div>}
      {a.comment && (
        <div className="text-xs text-slate-600" data-testid={`expense-approval-comment-${a.director_id}`}>
          Comentário: {a.comment}
        </div>
      )}
    </div>
  </li>
);

export const ApprovalsTimeline = ({ approvals }) => (
  <Card className="mt-4 p-5" testid="expense-timeline">
    <h3 className="font-serif-display text-xl">Histórico de aprovações</h3>
    <ul className="mt-3 space-y-2">
      {approvals.map((a) => (
        <ApprovalEntry key={a.director_id + a.decided_at} a={a} />
      ))}
    </ul>
  </Card>
);

export const PaymentProof = ({ doc }) => (
  <Card className="mt-4 p-5 border-l-4 border-l-[#002776]" testid="expense-payment-proof">
    <h3 className="font-serif-display text-xl">Comprovante de pagamento</h3>
    <p className="mt-1 text-sm text-slate-600">
      Pago em <strong>{formatDate(doc.paid_at)}</strong> por{" "}
      {doc.payment_proof.uploaded_by_name || "administrador"}.
    </p>
    {doc.payment_notes && <p className="mt-1 text-xs text-slate-500">Obs: {doc.payment_notes}</p>}
    <p className="mt-1 text-xs">
      Arquivo: <span className="font-mono">{doc.payment_proof.filename}</span>
    </p>
  </Card>
);
